import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { ClaimService } from 'src/app/services/claim.service';
 
@Component({
  selector: 'upsc-claim-details',
  templateUrl: './claim-details.component.html',
  styleUrls: ['./claim-details.component.scss']
})
export class ClaimDetailsComponent implements OnInit {
  loading: boolean = false;
  userDetails: any = null;
  userEmail: string = '';
  claimsList: any[] = [];
 
  constructor(
    private router: Router,
    private claimService: ClaimService
  ) {}
 
  ngOnInit(): void {
    try {
      const sessionData = sessionStorage.getItem('data');
 
      if (!sessionData) {
        this.handleUnauthenticatedUser();
        return;
      }
 
      this.userDetails = JSON.parse(sessionData);
 
      if (this.userDetails?.email) {
        this.userEmail = this.userDetails.email;
        // this.userEmail = "rpasumpon@ups.com";
      } else {
        this.handleUnauthenticatedUser();
        return;
      }
    } catch (error) {
      console.error('Error parsing session data:', error);
      this.handleUnauthenticatedUser();
      return;
    }
 
    this.loadClaimsFromApi();
  }
 
  loadClaimsFromApi() {
    this.loading = true;
    const payload = {
      reporterEmail: this.userEmail,
      claimSource: 'TUPSS – TCCP'
    };
 
    this.claimService.getReporterClaims(payload).subscribe(
      (response: any) => {
        let rawItems: any[] = [];
        if (response && response.results) {
          rawItems = response.results;
        } else if (response && response.data) {
          rawItems = response.data;
        } else if (Array.isArray(response)) {
          rawItems = response;
        }
 
        if (rawItems.length === 0) {
          this.claimsList = [];
          this.loading = false;
          return;
        }
 
        const detailRequests: Observable<any>[] = rawItems.map((item: any) => {
          const policyNum = item.policyNumber || item.policyNo || '';
          const claimNum = item.claimNumber || '';
 
          if (policyNum && claimNum) {
            return this.claimService.getClaimByIds(
              policyNum,
              [claimNum],
              false,
              ''
            );
          }
          return of(item);
        });
 
        forkJoin(detailRequests).subscribe(
          (detailsResponses: any[]) => {
            this.claimsList = detailsResponses.map((res: any, index: number) => {
              if (res && res.items && res.items[0]) {
                if (res.items[0]?.claimStatus?.claimState == 'closed' && (res.items[0]?.claimStatus?.claimSubStatus == 'IDR_Request' || res.items[0]?.claimStatus?.claimSubStatus == 'IDR_Request_1' || res.items[0]?.claimStatus?.claimSubStatus == 'IDR_Request_2' || res.items[0]?.claimStatus?.claimSubStatus == 'IDR_Request_Final') && res.items[0]?.claimStatus?.closedOutCome == 'incomplete_documentation_Ext') {
                  res.items[0].customerDisplayStatus = 'Documents Pending';
                }
                return res.items[0];
              } else if (res && res.results && res.results[0]) {
                return res.results[0];
              }
              return rawItems[index];
            });
            this.loading = false;
          },
          error => {
            console.error('Error fetching detailed claim info:', error);
            this.claimsList = rawItems;
            this.loading = false;
          }
        );
      },
      error => {
        this.loading = false;
        console.error('Error fetching reporter claims:', error);
      }
    );
  }
 
  handleUnauthenticatedUser() {
    this.router.navigate(['tccp']);
  }
 
  navigateToClaimDetails(claim: any) {
    const policyNumber = claim.policyNumber || claim.policyNo || '';
    const claimNumber = claim.claimNumber || '';
    const trackingNumber = claim.shippingDetails?.trackingNumber || '';
    const email = this.userEmail;
 
    const rawString = `${policyNumber}/${claimNumber}/tccp/${email}/${trackingNumber}`;
    const encodedString = btoa(rawString);
 
    const targetUrl = `${window.location.origin}/${encodedString}`;
    window.location.href = targetUrl;
  }
}